import { Component, OnInit } from '@angular/core';
import { MatDialogRef } from '@angular/material/dialog';

@Component({
  selector: 'app-warning-promotional-code',
  templateUrl: './warning-promotional-code.component.html',
  styleUrls: ['./warning-promotional-code.component.scss']
})
export class WarningPromotionalCodeComponent implements OnInit {

  constructor(
    private matDialogRef: MatDialogRef<WarningPromotionalCodeComponent>
  ) { }

  ngOnInit(): void {
  }

  continue(): void {
    this.matDialogRef.close(true);
  }

}
